import CommonPasswordChange from '../../../common/pages/secure/PasswordChange'

class PasswordChange extends CommonPasswordChange {
  constructor (props) {
    super(props)
    this.userRoleUrl = 'admin'
    this.userRole = 'admin'
  }
}

export default PasswordChange



// WEBPACK FOOTER //
// ./src/admin/pages/secure/PasswordChange.js